






import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class DefaultResultsNumber extends Vue {
  @Prop() private resultsNumber: number;
  @Prop() private query: string;

  get textParams() {
    return {
      resultsNumber: this.resultsNumber,
      query: this.query
    };
  }
}
